import { HomePage } from "pages/home/index2";
import PartnerForm from "pages/partner";
import { createBrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryFallback } from "components/ErrorBoundaryFallback";
import { logger } from "@caju-beneficios/monitoring";

function createPageErrorHandler(pageName: string) {
  return (error: Error, errorInfo: { componentStack: string }) => {
    logger.error({
      message: `${pageName} page error: ${error.message}`,
      error,
      context: {
        application: "quero-caju",
        page: pageName,
        componentStack: errorInfo.componentStack,
      },
    });
  };
}

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: (
        <ErrorBoundary
          fallback={<ErrorBoundaryFallback />}
          onError={createPageErrorHandler("Home")}
        >
          <HomePage />
        </ErrorBoundary>
      ),
    },
    {
      path: "/revenda",
      element: (
        <ErrorBoundary
          fallback={<ErrorBoundaryFallback />}
          onError={createPageErrorHandler("Partner")}
        >
          <PartnerForm />
        </ErrorBoundary>
      ),
    },
  ],
  {
    basename: process.env.PUBLIC_URL,
  }
);

export default router;
